import { Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { Dialog } from "cerulean";
import Account from "byzantine/src/Account";

interface BalanceDetailsModalProps {
  account: Account;
  dialogOpen: boolean;
  setDialogOpen: (newState: boolean) => void;
}

const BalanceDetailsModal = ({
  account,
  dialogOpen,
  setDialogOpen,
}: BalanceDetailsModalProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      title={l10n.getString("balance-details-modal-title")}
      isOpen={dialogOpen}
      onUserDismiss={() => {
        setDialogOpen(false);
      }}
    >
      <div className="margin--bottom margin--top--s">
        <Row>
          <Row.Item>
            <span className="attribute-label">{l10n.getString("balance-details-available-balance")}</span>
          </Row.Item>
          <Row.Item shrink>
            <span className="attribute-label">{account.balances.available}</span>
          </Row.Item>
        </Row>
        <p className="fontColor--secondary">
          {l10n.getString("balance-details-available-description")}
        </p>
      </div>
      <div>
        <Row>
          <Row.Item>
            <span className="attribute-label">{l10n.getString("balance-details-current-balance")}</span>
          </Row.Item>
          <Row.Item shrink>
            <span className="attribute-label">{account.balances.ledger}</span>
          </Row.Item>
        </Row>
        <p className="fontColor--secondary">
          {l10n.getString("balance-details-current-description")}
        </p>
      </div>
    </Dialog>
  );
};

export default BalanceDetailsModal;
